import { ProfileMenuGroupItemInterface } from '../models/profile-menu-group-item.interface';

export const profileMenusConst: {
  [key: string]: Array<ProfileMenuGroupItemInterface>;
} = {
  accountMenuItems: [
    {
      title: 'سرویس‌های پرکاربرد',
      icon: 'More',
      disabled: false,
      link: ['/profile', 'fas'],
    },
    {
      title: 'رمز عبور',
      icon: 'Lock',
      link: ['/profile', 'manage-password'],
    },
    {
      title: 'دستگاه‌های متصل',
      icon: 'digital-device',
      link: ['/profile', 'sessions'],
    },
    {
      title: 'کارت‌های ذخیره شده',
      icon: 'Bank-Card',
      link: ['/profile', 'saved-cards'],
    },
  ],
  alertMenuItems: [
    // {
    //   title: 'پیام‌ها',
    //   icon: 'Notification',
    //   disabled: true,
    //   link: ['/profile', 'notifications'],
    // },
    // {
    //   title: 'ثبت دیدگاه',
    //   icon: 'Consulting',
    //   link: ['/profile', 'feedback'],
    // },
    {
      title: 'دعوت از دوستان',
      icon: 'Add-Friend',
      link: ['/profile', 'referral'],
    },
  ],
  supportMenuItems: [
    // {
    //   title: 'چت با پشتیبانی',
    //   icon: 'consulting',
    //   isEmitter: true,
    // },
    {
      title: 'راهنما',
      icon: 'question-mark-circle',
      isEmitter: true,
    },
    {
      title: 'درباره ما',
      icon: 'Group',
      link: ['/profile', 'about-us'],
    },
    {
      title: 'شرایط و مقررات استفاده',
      icon: 'docuemnt-file',
      link: ['/profile', 'rules'],
    },
    {
      title: 'به روزرسانی',
      icon: 'Mobile',
      link: ['/profile', 'update'],
    },
  ],
};
